module.exports = __webpack_public_path__ + "static/media/microverse.d2aceb25.png";